import { Pipe, PipeTransform } from '@angular/core';
import { HubspotEnrichmentJobFilterParametersDto } from '../dto';
import { HubspotEnrichmentJobStatusEnum, HubSpotEnrichmentJobTriggerTypeEnum } from '../enums';

@Pipe({
  name: 'isAllowStartEnrichment',
  standalone: true,
})
export class IsAllowStartEnrichmentPipe implements PipeTransform {
  transform(job: HubspotEnrichmentJobFilterParametersDto): boolean {
    return (job?.jobTriggerType === HubSpotEnrichmentJobTriggerTypeEnum.MANUAL) && (job?.jobStatus === HubspotEnrichmentJobStatusEnum.REPORT_READY)
  }
}
